export default __webpack_public_path__ + "static/quote-2-8c959b628966ab8f8292c5acb5964d79.jpg";